import React from "react";
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';

import { withRouter } from 'react-router-dom';
import withCurrentUser from '../../../../hocs/with_current_user.js';
import withShowToast from '../../../../hocs/with_show_toast.js';
import withShowModal from '../../../../hocs/with_show_modal.js';
import { compose } from 'redux';

import pageStyles from "../../../styles/page_styles.js";
import { infoPageStyles } from "../../base_info_page.js";

import I18n from "../../../../base/i18n.js";

import BaseInfoPage from "../../base_info_page.js";
import Button from "../../../../base/buttons/button.js";

import { CountryModel } from "../../../../models/addresses/country.js";

import ShowCountryUseCase from "../../../../use_cases/admin/addresses/countries/show_country_use_case.js"
import SaveCountryUseCase from "../../../../use_cases/admin/addresses/countries/save_country_use_case.js"
import DeleteCountryUseCase from "../../../../use_cases/admin/addresses/countries/delete_country_use_case.js";

import Routes from "../../../routes.js";

const styles = theme => ({
});

class CountryInfoPage extends BaseInfoPage {

  loadItem() {
    if(this.identifier) {
      this.processDataLoader(this.showUseCase.execute(this.identifier));
    }
    else {
      this.item.key = "newItem";
      this.setState({
        loading: false
      });
    }
  }

  deleteConfirmMessage() {
    return I18n.t("admin.addresses.country.delete.confirm_message", {
      name: this.dataModel.displayValue(this.item)
    });
  }

  processLoadedItem(result) {
    const { data: { country } } = result;
    this.item = country;
  }

  rightButtons() {
    const { classes } = this.props;
    const { submit, loading } = this.state;

    return <React.Fragment>
      {
        this.identifier &&
          <Button className = { clsx(classes.formButton, classes.delete) }
                disabled = { submit || loading }
                onClick = { this.onDelete } >
          { I18n.t("action.delete") }
        </Button>
      }
      
    </React.Fragment>
  }
}

CountryInfoPage.defaultProps = {
  dataModel: CountryModel,
  showUseCase: ShowCountryUseCase,
  saveUseCase: SaveCountryUseCase,
  deleteUseCase: DeleteCountryUseCase,
  routeFunc: Routes.country
}

export default compose(
  withRouter, 
  withShowModal,
  withShowToast, 
  withCurrentUser, 
  withStyles(
    (theme) => ({
      ...pageStyles(theme),
      ...infoPageStyles(theme),
      ...styles(theme),
    }),
    { withTheme: true }
  )
)(CountryInfoPage);
